module.exports = "<div class=\"input-group {{$ctrl.inputSize}}\"><input class=\"form-control\" type=\"text\" name=\"{{$ctrl.inputName}}\" uib-datepicker-popup=\"{{$ctrl.format}}\" ng-model=\"$ctrl.dt\" ng-change=\"$ctrl.change\" is-open=\"$ctrl.popup.opened\" datepicker-options=\"$ctrl.dateOptions\" ng-required=\"{{$ctrl.inputRequired}}\" ng-disabled=\"$ctrl.inputDisabled == 'true'\" close-text=\"Close\"/><span class=\"input-group-btn\"><button class=\"btn btn-primary\" type=\"button\" ng-click=\"$ctrl.open()\"><i class=\"fa fa-calendar\"></i></button></span></div>"


//////////////////
// WEBPACK FOOTER
// ./client/components/datePicker/datePicker.pug
// module id = 50
// module chunks = 0